// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__7R21N","menu":"dropdown_menu__Wje2e","control":"dropdown_control__-vEVK","lg":"dropdown_lg__I6hr-","right":"dropdown_right__VUgHk"};